import React from "react";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
    {
        q: "Is this for me if I hate networking?",
        a: "Yes. This is for relationship builders who value authentic connections. No schmoozing required. We designed the community specifically for professionals who are tired of traditional networking approaches.",
    },
    {
        q: "Why do you charge $24.99?",
        a: "To keep the Goofballs out. This intentional price point ensures members are willing to invest in themselves and their professional relationships. If you won't invest in yourself, you're not ready for this community.",
    },
    {
        q: "Can anyone join?",
        a: "No. This is an invitation-only group. Everyone here is ready to work and grow. If you were sent a link, someone believed you belonged in the room.",
    },
    {
        q: "What makes this different from other networking groups?",
        a: "Our layered approach and focus on integrity creates a uniquely valuable experience. We actively filter out time-wasters and structure the community to reward genuine participation rather than aggressive self-promotion.",
    },
];

const FAQ = () => {
    return (
        <section
            id="faq"
            data-testid="faq-accordion"
            className="relative border-y border-[#d4af37]/15 bg-[#080a1f]"
        >
            <div className="max-w-3xl mx-auto px-5 md:px-10 py-24 md:py-32">
                <div className="text-xs uppercase tracking-[0.3em] text-[#f2c652] font-display mb-4 text-center">
                    VIII. Got Questions?
                </div>
                <h2 className="font-display font-black tracking-tighter text-4xl md:text-6xl leading-[0.95] text-[#f6f1e1] text-center mb-12 md:mb-16">
                    The{" "}
                    <span className="font-serif-italic font-light text-[#f2c652]">
                        honest
                    </span>{" "}
                    answers.
                </h2>

                <Accordion
                    type="single"
                    collapsible
                    className="w-full"
                    defaultValue="item-0"
                >
                    {FAQS.map((f, i) => (
                        <AccordionItem
                            key={i}
                            value={`item-${i}`}
                            className="border-b border-[#d4af37]/15"
                            data-testid={`faq-item-${i + 1}`}
                        >
                            <AccordionTrigger className="text-left font-display font-bold text-lg md:text-xl text-[#f6f1e1] hover:no-underline hover:text-[#f2c652] py-6">
                                {f.q}
                            </AccordionTrigger>
                            <AccordionContent className="text-[#f6f1e1]/65 font-body text-[15px] leading-relaxed pb-6 pr-6">
                                {f.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </section>
    );
};

export default FAQ;
